<template>
  <div class="results" v-hotkey="keymap" > <!--class="right-pane"-->
    <mobile-results-header 
      :can-undo="canUndo"
      :can-redo="canRedo"
      :more-results-mode="moreResultsMode"
      :modes-obj="modesObj"
      @back-to-text-prep="backToTextPrep"
      @copy="copyToClipboard"
      @undo="undoOneChange"
      @redo="redoOneChange"
      @syncfontsize="fontSize = moreResultsMode.fontSizeToSync"
      v-if="nakdanStyle.Mobile" />
    <div class="main-results-box"  v-bind:style="{ 'font-size': fontSize + 'px', 'line-height': lineHeight + 'px' }">
      <p>
        <span v-for="(wordObj, wordIndex) in localWordsArray" 
            :id="'span-A-word-' + wordObj.wordId"
            @click="wordClicked(wordIndex, $event)"
            @dblclick="wordDoubleClicked(wordIndex, $event)"
            :key="wordIndex">
          <span 
            :id="'span-B-word-' + wordObj.wordId" 
            class="clickable-word">
            <span v-for="(ch, c) in wordObj.sepBefore"
              :id="'span-S-word-' + wordObj.wordId + '-letterpos-' + c"
              :style="{'background-color': letterCursorHere 
                                            && !localLetterAddingMode && localCurrentWordIndex === wordIndex 
                                            && localCurrentLetterIndex === c ? cursorColor : ''}"
              :key="'word-'+wordIndex+'-sepBeforeChar-'+c"
                >{{(showLineBreakChar && ch === '\n' && !localLetterAddingMode && localCurrentWordIndex === wordIndex 
                                      && localCurrentLetterIndex === c ? '↳' : '\u2060') + ch}}<span
                    v-if="localLetterAddingMode && localCurrentWordIndex === wordIndex 
                            && localCurrentLetterIndex === c" :style="letterAddingCursorStyle">|</span>
            </span>
          </span>
          <span 
            :id="'span-C-word-' + wordObj.wordId" 
            v-bind:class="getWordClasses(wordObj, wordIndex)"
            class="clickable-word">
            <span v-for="(letterString, le) in wordObj.standardLetterArray.map((letterString, le) => 
              { return localShowAims && wordObj.displayVariants && wordObj.displayVariants[le].shiftNikudToNextRegExp
                    ? letterString.replace(wordObj.displayVariants[le].shiftNikudToNextRegExp, '') : letterString })"
              :id="'span-L-word-' + wordObj.wordId + '-letter-' + (wordObj.sepBefore.length + le)"
              :style="(localShowAims && ['אֽ', 'הֽ', 'וֽ', 'יֽ'].some(aim => letterString.startsWith(aim)) 
                      ? 'color: ' + aimDisplayColor + ';' : '') 
                        + (letterCursorHere
                          && !localLetterAddingMode && localCurrentWordIndex === wordIndex 
                          && localCurrentLetterIndex === (wordObj.sepBefore.length + le)
                          ? 'background-color: ' + cursorColor + '; border-radius: 5px' : '')"
              :key="'word-'+wordIndex+'-letterString-'+le"
                >{{ localShowAims || !(['אֽ', 'הֽ', 'וֽ', 'יֽ'].some(aim => letterString.startsWith(aim))) 
                          ? letterString.replace(/ֽ/, '').replace(/וֹ/g, '\ufb4b') : '\u2060'}}<span style="color: black"
              v-if="localShowAims && wordObj.displayVariants && wordObj.displayVariants[le].nikudFromPreviousToAdd"
                    >{{ wordObj.displayVariants[le].nikudFromPreviousToAdd }}</span><span
                    v-if="localLetterAddingMode && localCurrentWordIndex === wordIndex 
                    && localCurrentLetterIndex === (wordObj.sepBefore.length + le)"
                  :style="letterAddingCursorStyle">|</span>
            </span>
          </span>
          <span 
            :id="'span-D-word-' + wordObj.wordId" 
            class="clickable-word">
            <span v-for="(ch, c) in wordObj.sepAfter"
              :id="'span-S-word-' + wordObj.wordId + '-letterpos-' 
                                  + (wordObj.sepBefore.length + wordObj.standardLetterArray.length + c)"
              :style="{'background-color': letterCursorHere
                && !localLetterAddingMode && localCurrentWordIndex === wordIndex 
                && localCurrentLetterIndex === (wordObj.sepBefore.length + wordObj.standardLetterArray.length + c) 
                  ? cursorColor : ''}"
              :key="'word-'+wordIndex+'-sepAfterChar-'+c"
                >{{(ch === '\n' && !localLetterAddingMode && localCurrentWordIndex === wordIndex 
                  && localCurrentLetterIndex === (wordObj.sepBefore.length + wordObj.standardLetterArray.length + c) 
                    ? '↳' : '') + ch}}<span
                    v-if="localLetterAddingMode && localCurrentWordIndex === wordIndex 
                    && localCurrentLetterIndex === (wordObj.sepBefore.length + wordObj.standardLetterArray.length + c)"
                  :style="letterAddingCursorStyle">|</span>
            </span>
          </span>
        </span>
      </p>
    </div>
    <div v-if="showBottomTools" class="results-toolbar container">
      <div v-if="ifCopyingAims.USER_CONTROLLED" 
           class="copy-options-popup results-click-only-here" 
           v-show="showCopyOptions">
        <b-form-checkbox v-model="copyWithAims">
          העתק טקסט עם אימות קריאה
        </b-form-checkbox>
      </div>
      <div class="row d-flex flex-nowrap">
        <div class="tool-section export-tool-section col-auto">
          <b-button variant="link" class="font-size-inherit toolbar-item selection-non-clearer" @click="copyToClipboard" v-b-tooltip title="(Ctrl-C) העתק"><i-clone></i-clone></b-button>
          <b-button v-if="ifCopyingAims.USER_CONTROLLED" variant="link" class="font-size-inherit toolbar-item toolbar-subitem results-click-only-here selection-non-clearer" v-bind:disabled="localKetivMaleh" @click="copyToClipboardOptionsButtonClicked"><i-caret-down></i-caret-down></b-button>
        </div>
        <div class="tool-section export-tool-section download-tool-section col-auto">
          <b-button variant="link" class="font-size-inherit toolbar-item" @click="download" v-b-tooltip title="(Ctrl-D) הורד"><i-download></i-download></b-button>
        </div>
        <div class="tool-section zoom-tool-section col-auto">
          <b-button variant="link" class="font-size-inherit toolbar-item" @click="zoomIn" v-b-tooltip title="(Shift-+) הגדל"><i-search-plus></i-search-plus></b-button>
          <span class="px-1"></span>
          <b-button variant="link" class="font-size-inherit toolbar-item" @click="zoomOut" v-b-tooltip title="(Shift--) הקטן"><i-search-minus></i-search-minus></b-button>
        </div>
        <div class="tool-section undoredo-tool-section col-auto">
          <span v-b-tooltip title="(Shift-Z) ביטול"><b-button variant="link" class="font-size-inherit toolbar-item" v-bind:disabled="!canUndo" @click="undoOneChange"><i-share></i-share></b-button></span>
          <span class="px-1"></span>
          <span v-b-tooltip title="(Shift-Y) בצע מחדש"><b-button variant="link" class="font-size-inherit toolbar-item" v-bind:disabled="!canRedo" @click="redoOneChange"><i-reply></i-reply></b-button></span>
        </div>
        <div class="tool-section col-auto" @click.prevent="setShowAims(!localShowAims)">
          <b-form-checkbox inline class="pr-1" v-bind:disabled="localKetivMaleh" v-bind:checked="localShowAims">
          הצג אימות קריאה
          </b-form-checkbox>
        </div>
        <div v-if="editNikudPopup.PRESENT" class="tool-section col-auto">
            <b-button variant="link"
                      @click="openEditNikudPopup"
                      class="font-size-inherit tool-section-btn" v-b-tooltip title="(Shift-E) עריכת טקסט"><i-pencil-alt></i-pencil-alt> עריכת טקסט</b-button>
        </div>
        <div class="tool-section back-tool-section col pl-1">
          <span class="saved-state-msg"></span>
          <b-button id="loadNewTextButton" variant="link" class="mr-auto font-size-inherit tool-section-btn" @click="backToTextPrep">טען טקסט חדש <i-arrow-alt-circle-left></i-arrow-alt-circle-left></b-button>
        </div>
      </div>
    </div>
    <b-modal centered
             v-model="showDownloadPopup"
             ok-title="הורד"
             cancel-title="ביטול"
             @ok="actuallyDownload"
             @show="testForQamatzQatan"
    >
      <template slot="modal-header"><div><i-download></i-download><span class="modal-header-title"> הורדת קובץ</span></div></template>
      <div class="showDownloadPopupContent">
        <div class="row">
          <div class="col-4 mb-3">סוג קובץ</div>
          <div class="col-8 text-right mb-3">
            <dicta-dropdown v-model="chosenDownloadTypeOption" :options="downloadTypes"
                            display-field="displayText"></dicta-dropdown>
          </div>
        </div>
        <div v-show="chosenDownloadTypeOption.fileTypeName === 'docx' && $store.state.originalDocument.source && $store.state.originalDocument.source.type === 'docx'"
             class="row"
        >
          <div class="col-4 mb-3">עיצוב מסמך</div>
          <div class="col-8 mb-3">
            <div @click="keepFormattingOption=true"><b-form-radio id="doKeep" :value="true" v-model="keepFormattingOption"> שמור צורת מקור</b-form-radio></div>
            <div @click="keepFormattingOption=false"><b-form-radio id="doNotKeep" :value="false" v-model="keepFormattingOption"> אל תשמור צורת מקור</b-form-radio></div>
          </div>
        </div>
        <div v-show="chosenDownloadTypeOption.fileTypeName === 'docx' && $store.state.originalDocument.source && $store.state.originalDocument.source.type === 'docx' && keepFormattingOption" class="px-3 py-2 small special-gray">
          ייתכנו שיבושים בהורדת קובץ Word.docx עם שמירת צורת מקור. מומלץ לוודא שהטקסט בקובץ תקין לפני שאתם ממשיכים הלאה.
        </div>
        <div class="row" v-if="ifDownloadingAims.USER_CONTROLLED" v-show="!localKetivMaleh">
          <div class="col-4 mb-3">אימות קריאה</div>
          <div class="col-8 mb-3">
            <div @click="downloadWithAimsOption=true"><b-form-radio id="withAims" :value="true" v-model="downloadWithAimsOption"> שמור אימות קריאה</b-form-radio></div>
            <div @click="downloadWithAimsOption=false"><b-form-radio id="withoutAims" :value="false" v-model="downloadWithAimsOption"> אל תשמור אימות קריאה</b-form-radio></div>
          </div>
        </div>
        <div v-show="chosenDownloadTypeOption.fileTypeName === 'docx' && textIncludesQamatzQatan" class="py-0 qamatz-qatan-font-support-warning">
          <hr class="mt-0 mb-1" />
          * שימו לב - ישנם גופנים שאינם תומכים בקמץ קטן
        </div>
      </div>
    </b-modal>
    <b-modal v-model="showBackToTextPrepPrompt"
             id="back-to-text-modal"
             size="sm"
             :centered="!nakdanStyle.Mobile"
             hide-header
             ok-title="עבור"
             cancel-title="ביטול"
             footer-class="back-to-text-footer"
             @ok="actuallyBackToTextPrep">
      <p v-if="nakdanStyle.Mobile" class="reload-warning border-bottom border-secondary">טעינת טקסט חדש, תמחוק את הטקסט הקיים</p>       
      <p v-else class="text-center mb-0">טעינת טקסט חדש, תמחוק את <br/>הטקסט הקיים</p>
      <span v-bind:class="{'text-center': !nakdanStyle.Mobile}"><b-form-checkbox v-model="disableBackToTextPrepPromptOption"><span v-bind:class="{'mr-2': nakdanStyle.Mobile}">אל תציג שוב</span></b-form-checkbox></span>
    </b-modal>
    <div id="text-copied-msg" class="notify-msg" style="display:none;">
      <p class="f white">text will be filled in by code</p>
    </div>
    <edit-nikud-pane v-if="editNikudPopup.ENABLE && editNikudProps.showEditNikud" :edit-nikud-props="editNikudProps" :modes-obj="modesObj" />
  </div>
</template>

<script>
// @ is an alias to /src

import nikudMixins from '@/mixins/nikudMixins'
import $ from 'jquery'
import vuexUndoRedo from '@/mixins/vuexUndoRedo'
import EditNikudPane from './EditNikudPane'
import serviceMixins from '@/mixins/serviceMixins'
import {StateSaver} from '@/store/stateChanges'
import navigationMixins from '@/mixins/navigationMixins'
import {AppConfig as appConfig} from '../appConfig'
import styleGlobals from '@/js/styleGlobals'
import {generateWordDoc} from '@/js/wordImportExport'
import {NIKUD} from '@/js/commonHebrew'
import {SimpleVsProConfig} from '@/simpleVsProConfig.js'
import {NakdanStyle, MobileVsDesktopConfig} from '@/mobileVsDesktopConfig.js'
import MobileResultsHeader from '@/components/MobileResultsHeader.vue'
import {processSpecialNikudDisplayProps} from '@/js/specialNikud'

const DEFAULT_FONT_SIZE = styleGlobals.DEFAULT_FONT_SIZE
const MAX_FONT_SIZE = styleGlobals.MAX_FONT_SIZE
const MIN_FONT_SIZE = styleGlobals.MIN_FONT_SIZE

var copyToClipboardRecursionPreventor = false

const downloadTypes = [
  {displayText: 'Word.docx', fileTypeName: 'docx'},
  {displayText: 'Text.txt', fileTypeName: 'text'},
  {displayText: 'WebPage.html', fileTypeName: 'html'},
]

const LETTER_ADDING_MODE_CURSOR_HTML = '<span style="color: cyan; background-color: #9cd1ff">|</span>'
      /* '<div style="display: inline-block; position: relative; bottom: -3px; '
        + 'background-color: black; height: ' + (this.fontSize - 1) + 'px; width: 1.5px"> <div '
        + 'style="position: relative; bottom: ' + (this.fontSize + 5) + 'px; left: 0px; width: 0; '
        + 'color: black; border-top: 5px solid black; border-left: 5px solid transparent"></div></div>' */

export default {
  name: 'NikudResultsContainer',
  mixins: [
    nikudMixins, /* for the direct use of: localLetterAddingMode, localCurrentWordIndex, localCurrentLetterIndex,
                      localCurrentWord, currentLetterNotSep, modalOpen(), display(),
                      and showCopiedTextMessage() ...
                    ...and for the use, as an undo()-and-redo() dependency, of: getSafeWordAndLetter() */
    vuexUndoRedo, // for undo(), redo(), canUndo, & canRedo
    serviceMixins, // for gtag()
    navigationMixins // for moveToWordMethod() and scrollResultsWindow()
  ],
  props: ['modesObj', 'editNikudProps'],
  components: {
    MobileResultsHeader,
    EditNikudPane
  },
  data () {
    return {
      fontSize: DEFAULT_FONT_SIZE,
      currentSelection: [],
      copyingElement: null,
      showDownloadPopup: false,
      backToTextPrepConfirmed: false,
      disableBackToTextPrepPromptOption: false,
      showBackToTextPrepPrompt: false,
      downloadTypes: downloadTypes,
      chosenDownloadTypeOption: downloadTypes[0],
      keepFormattingOption: true,
      intervalHolder: null,
      moreResultsMode: { // used only in "Mobile" style
        showMoreResultsTools: false,
        fontSizeToSync: DEFAULT_FONT_SIZE,
        showAimsToSync: this.$store.state.postSubmissionOptions.showAims
      },
      // data items below here are used only by the 'Pro' Nakdan
      showCopyOptions: false,
      copyWithAims: false,
      downloadWithAimsOption: false,
      textIncludesQamatzQatan: false
    }
  },
  computed: {
    nakdanStyle () {
      return NakdanStyle // Mobile: window.innerWidth < 992, Desktop: window.innerWidth >= 992
    },
    showBottomTools () {
      return MobileVsDesktopConfig.RESULTS_TOOLS.BOTTOM
    },
    editNikudPopup () {
      return SimpleVsProConfig.EDIT_NIKUD_POPUP // from SimpleVsProConfig.js: ENABLE: true, PRESENT: NakdanType.Pro
    },
    ifCopyingAims () {
      return SimpleVsProConfig.EXPORT_AIMS
    },
    ifDownloadingAims () {
      return SimpleVsProConfig.EXPORT_AIMS
    },
    startByDoubleClick () {
      return SimpleVsProConfig.START_BY_DOUBLE_CLICK && !(NakdanStyle.Mobile)
    },
    // BOTH THE ABOVE (from SimpleVsProConfig.js): USER_CONTROLLED: NakdanType.Pro, FOLLOW_DISPLAY: NakdanType.Simple
    letterCursorHere () {
      return SimpleVsProConfig.MAIN_RESULTS_WINDOW.USE_LETTER_CURSOR
    },
    showLineBreakChar () {
      return SimpleVsProConfig.MAIN_RESULTS_WINDOW.SHOW_LINE_BREAK_CHAR
    },
    localWordsArray () {
      return this.$store.state.allWorkingNikud.wordsArray
    },
    localShowAims () {
      return this.$store.state.postSubmissionOptions.showAims
    },
    localKetivMaleh () {
      return this.$store.state.preSubmissionOptions.ketivMaleh
    },
    lineHeight () {
      return this.fontSize + 5
    },
    cursorColor () {
      return styleGlobals.cursorColor
    },
    aimDisplayColor () {
      return styleGlobals.aimColor
    },
    letterAddingCursorStyle () {
      return {'background-color': styleGlobals.cursorColor, 'color': 'cyan'}
    },
    keymap () {
      var keymapObj = {
        'shift+c': () => { if (!(this.modalOpen())) this.copyToClipboard() },
        'ctrl+shift+L': () => { if (!(this.modalOpen())) this.copyToClipboard('keep-metegs') },
        'shift+=': (e) => { 
          if (!(this.modalOpen()) && (this.localNikudKeyboard !== 'old' || !(e.getModifierState('CapsLock')))) {
            this.zoomIn() 
          }
        },
        'ctrl+=': (e) => { 
          if (!(this.modalOpen()) && (this.localNikudKeyboard !== 'old' || !(e.getModifierState('CapsLock')))) {
            this.zoomIn() 
          }
        },
        'shift+-': (e) => { 
          if (!(this.modalOpen()) && (this.localNikudKeyboard !== 'old' || !(e.getModifierState('CapsLock')))) {
            this.zoomOut() 
          }
        },
        'ctrl+-': (e) => { 
          if (!(this.modalOpen()) && (this.localNikudKeyboard !== 'old' || !(e.getModifierState('CapsLock')))) {
            this.zoomOut() 
          }
        },
        'shift+z': () => { if (!(this.modalOpen())) this.undoOneChange() },
        'ctrl+z': () => { if (!(this.modalOpen())) this.undoOneChange() },
        'shift+y': () => { if (!(this.modalOpen())) this.redoOneChange() },
        'ctrl+y': () => { if (!(this.modalOpen())) this.redoOneChange() },
        'shift+d': () => { if (!(this.modalOpen())) this.download() },
        'ctrl+d': () => { if (!(this.modalOpen())) this.download() },
        'alt+n': this.backToTextPrep,
        'enter': () => { if (this.showDownloadPopup) this.actuallyDownload() }
      }
      if (this.editNikudPopup.ENABLE) keymapObj['shift+e'] = () => { 
        if (!(this.modalOpen())) this.openEditNikudPopup() 
      }
      return keymapObj
    }
  },
  watch: {
    localCurrentWordIndex () {
      this.currentSelection = []
      document.getSelection().removeAllRanges()
    },
    localCurrentLetterIndex () {
      this.currentSelection = []
      document.getSelection().removeAllRanges()
    },
    localShowAims (newLocalShowAims) {
      if (newLocalShowAims) {
        this.gtag("event", "change display", {
          'event_category': 'all word displays',
          'event_label': 'show aimot kriah'
        })
      }
    }
  },
  methods: {
    testForQamatzQatan () {
      if (SimpleVsProConfig.IMPLEMENT_QAMATZ_QATAN) { // otherwise textIncludesQamatzQatan always stays false!
                                                      // (so no need for condition in font support warning)
        // console.log('running testForQamatzQatan()')
        this.textIncludesQamatzQatan = this.$store.state.allWorkingNikud.wordsArray.some(
          word => word.chosenWordString.includes(NIKUD.QAMATZ_QATAN))
      }
    },
    wordClicked (wordIndex, e) {
      // console.log(e.target.attributes.id.value)
      if (SimpleVsProConfig.MAIN_RESULTS_WINDOW.START_BY_SINGLE_CLICK 
          && !(this.modesObj.firstClickOrDoubleClickDone)) this.modesObj.firstClickOrDoubleClickDone = true
      if (SimpleVsProConfig.MAIN_RESULTS_WINDOW.CAN_CLICK_ON_LETTERS && e.target.attributes.id.value.includes('letter')) {
        this.changeWordAndLetter({
          word: wordIndex,
          letter: parseInt(e.target.attributes.id.value.split('-')[5]) // skips 'span-L-word-w-letter-' prefix
        })
      } else if (!(this.startByDoubleClick) // i.e. don't NEED double click
                  || this.modesObj.firstClickOrDoubleClickDone) {
        this.changeCurrentWordIndex(wordIndex)
        if (MobileVsDesktopConfig.HITTING_WORD_OPENS_OPTIONS) this.$emit('open-options')
      }
    },
    wordDoubleClicked (wordIndex, e) {
      if (SimpleVsProConfig.MAIN_RESULTS_WINDOW.START_BY_DOUBLE_CLICK && !(this.modesObj.firstClickOrDoubleClickDone)) {
        this.modesObj.firstClickOrDoubleClickDone = true
        this.wordClicked(wordIndex, e)
      }
    },
    openEditNikudPopup () { // relevant only in "Pro" Nakdan
      this.editNikudProps.workingIndices = this.currentSelection.length ? this.currentSelection : [this.localCurrentWordIndex]
      // console.log('this.editNikudProps.workingIndices:')
      // console.log(this.editNikudProps.workingIndices)
      this.modesObj.letterAddingMode = false
      this.editNikudProps.showEditNikud = true
      setTimeout(() => { $('.nikud-manual-edit-area').focus() }, 10)
    },
    changeCurrentWordIndex (w) {
      this.moveToWordMethod(w)
    },
    changeCurrentLetterIndex (le) { // currently never used here! (a COPY in ManualNikudPane is used a lot)
      this.$store.commit('SET_CURRENT_LETTER_INDEX', le)
    },
    changeWordAndLetter (indicesObj) {
      this.$store.commit('SET_WORD_AND_LETTER', indicesObj)
    },
    setShowAims (a) {
      // console.log('committing SET_SHOW_AIMS - setting to ' + a)
      if (!(this.localKetivMaleh)) this.$store.commit('SET_SHOW_AIMS', a)
    },
    preCopy (metegs) {
      this.copyingElement = $("<textarea>")
      $("body").append(this.copyingElement)
      var wordsArrayToCopy = this.currentSelection.length 
        ? this.localWordsArray.filter((w, i) => this.currentSelection.includes(i)) : this.localWordsArray
      var actuallyCopyWithAims
      if (this.ifCopyingAims.USER_CONTROLLED) actuallyCopyWithAims = this.copyWithAims
      if (this.ifCopyingAims.FOLLOW_DISPLAY) actuallyCopyWithAims = this.localShowAims
      this.copyingElement.val(
        processSpecialNikudDisplayProps(wordsArrayToCopy, actuallyCopyWithAims, metegs)).select()
    },
    postCopy () {
      this.copyingElement.remove()
      this.copyingElement = null
      this.showCopiedTextMessage()
    },
    copyToClipboard (mode = 'no-metegs') {
      if (!(this.copyingElement || copyToClipboardRecursionPreventor)) {
        this.preCopy(mode)
        copyToClipboardRecursionPreventor = true
        document.execCommand("copy")
        copyToClipboardRecursionPreventor = false
        this.postCopy()
      }
    },
    copyToClipboardOptionsButtonClicked () {
      if (!(this.localKetivMaleh)) this.showCopyOptions = !(this.showCopyOptions)
      document.activeElement.blur()
    },
    zoomIn () {
      if (this.fontSize < MAX_FONT_SIZE) {
        this.fontSize += 1
      }
      document.activeElement.blur()
    },
    zoomOut () {
      if (this.fontSize > MIN_FONT_SIZE) {
        this.fontSize -= 1
      }
      document.activeElement.blur()
    },
    undoOneChange () {
      if (this.canUndo) {
        const allPostSubmissionOptions = Object.assign({}, this.$store.state.postSubmissionOptions)
        this.undo()
        this.$store.commit('SET_ALL_POST_SUBMISSION_OPTIONS', allPostSubmissionOptions)
      }
      document.activeElement.blur()
    },
    redoOneChange () {
      if (this.canRedo) this.redo()
      document.activeElement.blur()
    },
    backToTextPrep () {
      document.activeElement.blur()
      if (!(this.$store.state.postSubmissionOptions.disableBackToTextPrepPrompt)) { 
        this.showBackToTextPrepPrompt = true 
      } else this.actuallyBackToTextPrep()
    },
    actuallyBackToTextPrep () {
      this.showBackToTextPrepPrompt = false
      this.backToTextPrepConfirmed = true
      if (this.disableBackToTextPrepPromptOption) this.$store.commit('SET_DISABLE_BACK_TO_TEXT_PREP_PROMPT', true)
      this.$store.commit('EDIT_DOCUMENT_TEXT', '')
      this.$router.push({ name: 'text-prep' })
    },
    download () {
      this.showDownloadPopup = true
      document.activeElement.blur()
    },
    actuallyDownload () {
      this.showDownloadPopup = false
      var downloadWithAims
      if (this.ifDownloadingAims.USER_CONTROLLED) downloadWithAims = this.downloadWithAimsOption
      if (this.ifDownloadingAims.FOLLOW_DISPLAY) downloadWithAims = this.localShowAims
      var text = /* by default */ processSpecialNikudDisplayProps(this.localWordsArray, downloadWithAims)
      console.log(text)
      var element
      if (this.chosenDownloadTypeOption.fileTypeName === 'text') {
        element = document.createElement('a')
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text))
        element.setAttribute('download', 'NakdanResults' + Math.floor(Math.random() * 100000000) + '.txt')
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
        document.body.removeChild(element)
      } else if (this.chosenDownloadTypeOption.fileTypeName === 'html') {
        text = '<body dir="rtl" style="font-size: ' + DEFAULT_FONT_SIZE + 'px">' + this.localWordsArray.map(
          (wordObj) => {
            const htmlIfNotCurrent = this.getHtmlIfNotCurrent(wordObj)
            return htmlIfNotCurrent.before + '<span options="'
                + JSON.stringify(wordObj.options).replace(/"/g, '&quot;')
                + '" chosen-option-index="' + wordObj.chosenOptionIndex
                + '" original-word="' + wordObj.originalWord
                + '" manual-nikud="' + wordObj.manualNikud
                + '" edited-nikud="' + wordObj.editedNikud
                + '" choice-type="' + wordObj.choiceType + '"'
                + (wordObj.altered ? ' style="color: #bd10e0"' : '') + '>'
                + (downloadWithAims ? htmlIfNotCurrent.wordShowingAims 
                    : htmlIfNotCurrent.wordNotShowingAims) + '</span>' + htmlIfNotCurrent.after
          }).join('') + '</body>'
        element = document.createElement('a')
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text))
        element.setAttribute('download', 'NakdanResults' + Math.floor(Math.random() * 100000000) + '.html')
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
        document.body.removeChild(element)        
      } else { /* this.chosenDownloadTypeOption.fileTypeName === 'docx' */
        var base64 = generateWordDoc(this.$store.state, {keepFormattingOption: this.keepFormattingOption})
        // console.log(base64)
        element = document.createElement('a')
        element.setAttribute('href', 'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,' + base64) // base64js.fromByteArray(contents))
        element.setAttribute('download', 'NakdanResults' + Math.floor(Math.random() * 100000000) + '.docx')
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
        document.body.removeChild(element)
      }
    },
    tryToGetWordSelection () {
      var workingIndices = []
      var currentSelection = window.getSelection()
      if (typeof currentSelection !== 'undefined' && currentSelection.anchorNode !== null) {
        const end1Id = currentSelection.anchorNode.parentElement.id
        const end2Id = currentSelection.focusNode.parentElement.id
        // console.log('selection between ' + end1Id + ' and ' + end2Id)
        if (end1Id.includes('-word-') && end2Id.includes('-word-')) {
          const end1Index = this.indexFromWordId(parseInt(end1Id.split('-')[3])) // skips 'span-X-word-' prefix
          const end2Index = this.indexFromWordId(parseInt(end2Id.split('-')[3])) // skips 'span-X-word-' prefix
          const higher = Math.max(end1Index, end2Index)
          const lower = Math.min(end1Index, end2Index)
          // console.log('I.E. words ' + lower + ' through ' + higher + ' selected')
          workingIndices = [...Array(higher - lower + 1).keys()].map(i => i + lower)
        }
      }
      return workingIndices // If no selection: empty array (as initialized)
    },
    blockDoubleClick () {
      setTimeout(() => {
        this.currentSelection = []
        if (document.selection && document.selection.empty) {
          document.selection.empty()
        } else if (window.getSelection) {
          var sel = window.getSelection()
          sel.removeAllRanges()
        }
      }, 1)
    },
    indexFromWordId (wordId) {
      return this.$store.state.wordIdToIndexMap[wordId]
    },
    getWordHtml (wordObj, whetherCurrentWord, letterArray, aimCondition = this.$store.state.postSubmissionOptions.showAims) {
      const CHOLAM = 'ֹ'
      var wordHtml = ''
      var shiftedCholam = false
      var getShiftedCholam = false
      letterArray.forEach((letterString, i) => {
        let currentLetterString = letterString
        wordHtml += '<span id="span-L-word-' + wordObj.wordId + '-letter-' + (i + wordObj.sepBefore.length) + '"'
        var styles = []
        if (['אֽ', 'הֽ', 'וֽ', 'יֽ'].includes(letterString)) {
          letterString = aimCondition ? letterString[0] : ''
          currentLetterString = aimCondition ? letterString[0] : ''
          styles.push('color: ' + styleGlobals.aimColor)
        } else if (aimCondition && letterArray[i + 1] === 'וֽ' && letterString[letterString.length - 1] === CHOLAM) {
          currentLetterString = letterString.slice(0, letterString.length - 1)
          shiftedCholam = true
        }
        if (whetherCurrentWord && !(this.localLetterAddingMode)
            && (this.localCurrentLetterIndex - this.localCurrentWord.sepBefore.length === i)) {
          styles.push('background-color: ' + styleGlobals.cursorColor + '; border-radius:5px')
        }
        if (styles.length) wordHtml += ' style="' + styles.join('; ') + '"'
        wordHtml += '>' + currentLetterString + '</span>' + (getShiftedCholam ? CHOLAM : '')
        if (shiftedCholam) { shiftedCholam = false; getShiftedCholam = true } else getShiftedCholam = false
        if (whetherCurrentWord && this.localLetterAddingMode
            && (this.localCurrentLetterIndex - this.localCurrentWord.sepBefore.length === i)) {
          // wordHtml += '<span style="color: cyan; background-color: #9cd1ff">|</span>'
          wordHtml += LETTER_ADDING_MODE_CURSOR_HTML
        }
      })
      return wordHtml // (no need to replace line breaks - they're only in separators!) // this.display(wordHtml)
    },
    getSepHtml (wordObj, sepType, whetherCurrentWord, letterArray) {
      var wordHtml = ''
      const sepChars = (sepType === 'before' ? wordObj.sepBefore : wordObj.sepAfter)
      var indexDelta = 0 // for 'before'
      if (sepType === 'after') indexDelta += (letterArray.length + wordObj.sepBefore.length)
      sepChars.split('').forEach((letterString, i) => {
        wordHtml += '<span id="span-S-word-' + wordObj.wordId + '-letterpos-' + (i + indexDelta) + '"'
        if (whetherCurrentWord && !(this.localLetterAddingMode) && (this.localCurrentLetterIndex === i + indexDelta)) {
          wordHtml += (letterString !== '\n') 
            ? ' style="background-color: ' + styleGlobals.cursorColor + ';">' + letterString + '</span>'
            : ' style="background-color: ' + styleGlobals.cursorColor + '">' + '↳' + '</span>' + letterString
        } else wordHtml += '>' + letterString + '</span>'
        if (whetherCurrentWord && this.localLetterAddingMode && (this.localCurrentLetterIndex === i + indexDelta)) {
          wordHtml += LETTER_ADDING_MODE_CURSOR_HTML
        }
      })
      return this.display(wordHtml)
    },
    getHtmlIfNotCurrent (wordObj) {
      const letterArray = wordObj.standardLetterArray
      const whetherCurrentWord = false
      return {
        before: this.getSepHtml(wordObj, 'before', whetherCurrentWord, letterArray),
        wordShowingAims: this.getWordHtml(wordObj, whetherCurrentWord, letterArray, true),
        wordNotShowingAims: this.getWordHtml(wordObj, whetherCurrentWord, letterArray, false),
        after: this.getSepHtml(wordObj, 'after', whetherCurrentWord, letterArray)
      }
    },
    getWordClasses (wordObj, wordIndex) {
      let classes = []
      if (wordIndex === this.localCurrentWordIndex && this.currentLetterNotSep) {
        classes.push('current-word')
      } else if (wordObj.altered) {
        classes.push('altered-word')
      }
      if (appConfig.SHOW_PASUK_FONT) {
        if (wordObj.option1Pasuk && wordObj.choiceType === 'option' && wordObj.chosenOptionIndex === 0) {
          classes.push('f-koren')
        }
      }
      return classes
    },
    beforeUnloadHandler (event) {
      // var unsaved = true // no "being unsaved" is needed
      if (!(this.$store.state.loginInProgress) && !(this.modesObj.globals.allowLeaving) && process.env.NODE_ENV !== "development") { // (unsaved) {
        event.preventDefault()
        event.returnValue = 'preventing unload'
        return 'preventing unload'
      }
    }
  },
  beforeDestroy () {
    window.onkeydown = null
    $(document).unbind('copy')
    $(document).unbind('dblclick', this.blockDoubleClick)
    clearInterval(this.intervalHolder)
  },
  mounted () {
    $(document).on('click', '.results-click-only-here', function (e) {
      e.stopPropagation() // note: only works b/c elements exist at this time!
    })
    $(document).on('click', () => {
      this.showCopyOptions = false
    })
    this.disableBackToTextPrepPromptOption = this.$store.state.postSubmissionOptions.disableBackToTextPrepPrompt
    window.onkeydown = (e) => { 
      if (!(this.modalOpen())) {
        return !([32, 37, 38, 39, 40].includes(e.keyCode)) // suppress spacebar and arrow key scrolling
      }
    }
    $(document).on('mouseup', () => { 
      var newSelection = this.tryToGetWordSelection()
      if (newSelection.length) this.currentSelection = newSelection
    })
    $(document).on('mousedown', (e) => { 
      if (!(e.target.className.split().includes('selection-non-clearer'))) this.currentSelection = []
    })
    $(document).bind('copy', this.copyToClipboard)
    $(document).on('dblclick', this.blockDoubleClick)
    this.intervalHolder = setInterval(() => {
      StateSaver.saveState(this.$store.state)
      console.log('Saved state! Time: ' + new Date().toTimeString().split(' ')[0])
      const messageElement = document.getElementsByClassName('saved-state-msg')[0]
      if (messageElement) {
        messageElement.textContent = 'השינויים נשמרו'
        setTimeout(() => { messageElement.textContent = '' }, 4000)
      }
    }, 300000)
    if (this.localCurrentWordIndex >= 0) {
      setTimeout(() => {
        this.scrollResultsWindow()
      }, 50)
    }
    window.addEventListener('beforeunload', this.beforeUnloadHandler)
  },
  beforeRouteLeave (to, from, next) {
    if (!(this.backToTextPrepConfirmed) && !(this.$store.state.loginInProgress) && process.env.NODE_ENV !== "development") {
      const answer = window.confirm('נא לאשר שאתם באמת רוצים לצאת') // actually the browser will use its own words
      if (!answer) {
        next(false)
        return
      }
    }
    window.removeEventListener('beforeunload', this.beforeUnloadHandler)
    next()
  }
}
</script>
<style lang="scss">
  @media (max-width: 767px) {
   #back-to-text-modal{
     .modal-dialog{
       margin:0;
       .modal-content{
        border-radius: 0;
        box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.2);
        .reload-warning{
          padding-bottom:13px;
        }
        .custom-checkbox .custom-control-label:after, .custom-checkbox .custom-control-label:before {
          width: 1.25rem;
          height: 1.25rem;  
        }
       }
       .back-to-text-footer{
         justify-content: right;
         padding-top: 0;
         border:none;
         border-radius:0;
          button{
            max-width: 125px
          }
       }     
     }
   } 
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.results {
  height: 100%;
  @media (max-width: 767px) {
    height: 85vh;
  }
  display: flex;
  flex-direction: column;
}
.main-results-box {
  flex: auto;
  height: 100%;
  width: 100%;
  font-family: mft_narkisclassic;
/* (now handled dynamically) font-size: 25px;
  line-height: 30px; */
  border-style: none;
  padding: 10px;
  overflow-y: auto;
  white-space: pre-line;
  line-break: loose;
}

.results-side-mobile .main-results-box{
  padding-right:15px;
  padding-left:15px;
  height: 100vh;
  max-height: 100%;
}

.clickable-word {
  cursor: pointer;
}
.current-word {
  background-color: #d6ecff;
  border-radius: 5px;
}
.altered-word {
  color: #bd10e0;
}
.load-button {
  position: absolute;
  bottom: 5px;
  right: 30px;
}
.results-toolbar {
  width: 100%;
  padding: 0;
}
.results-toolbar .row {
  /*width: 96.5%;*/
  margin: 0;
}
span.aim-text {
  color: purple !important;
}
.tool-section {
  border-style: solid;
  border-width: 1px 1px 0 0;
  border-color: #E3E3E3;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding-right: 10px;
  padding-left: 10px;
  height: 40px;
}
.tool-section:first-child {
  border-inline-start: 0;
}
.tool-section:last-child {
  border-inline-end: 0;
}
.back-tool-section {
  flex-shrink: 1;
  min-width: 10px;
}
.special-gray {
  background-color: #f6f6f6
}
.tool-section a {
  margin: 2px;
}
.selection-non-clearer {
  padding: 0;
}
.toolbar-item {
  padding: 0 4px;
}
.toolbar-subitem {
  padding: 0 2px !important;
  height: 18px;
  font-size: 12px !important;
  line-height: 18px;
}
.copy-options-popup {
  bottom: 46px;
  right: 6px;
  font-family: Arimo;
  height: 40px;
  padding: 8px 20px;
  font-size: 16px;
  line-height: 24px;
  vertical-align: top;
}
.tool-section-btn {
  padding: 1px 8px;
  border-radius: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.right-column {
  float: right; 
  padding-right: 8px; 
  width: 35%
}
.download-popup p {
  cursor: pointer;
  margin: 0;
}
.prompt-popup {
  text-align: center;
}
.prompt-popup p {
  margin: 4px;
}
.font-size-inherit {
  font-size: inherit;
}
.showDownloadPopupContent{
  min-height:200px;
}
.qamatz-qatan-font-support-warning {
  position: absolute; 
  bottom: 0; 
  width: calc(100% - 32px);
}
.saved-state-msg{
  color: gray;
}
</style>
